// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3f629388] .el-dialog__body {\n  padding-top: 15px;\n}\n[data-v-3f629388] .el-dialog {\n  margin-bottom: 0 !important;\n}\n.icons-container[data-v-3f629388] {\n  display: flex;\n  justify-content: center;\n  font-size: 30px;\n  color: #d5d5d5;\n  font-weight: 600;\n  align-items: center;\n}\n.icons-container > *[data-v-3f629388] {\n  margin-right: 20px;\n  margin-left: 20px;\n}", ""]);
// Exports
module.exports = exports;
